import { Action, createReducer, on } from '@ngrx/store';
import * as _ from 'lodash';
import moment from 'moment';
import { CACHED_REQUEST_STATUS, CachedPOSTRequest } from '../../classes/cached-request';
import {
    addRequestToQueue,
    removeRequestFromQueue,
    synchronizeQueue,
    updateRequestInQueue,
} from '../actions/request-queue.actions';
import { RequestQueueState, initialRequestQueueState } from '../types/request-queue.state';

const addRequestToQueueReducer = (
    state: Readonly<RequestQueueState>,
    props: { request: CachedPOSTRequest },
): Readonly<RequestQueueState> => {
    return { ...state, requests: [...state.requests, props.request] };
};

const removeRequestFromQueueReducer = (
    state: Readonly<RequestQueueState>,
    props: { request: CachedPOSTRequest },
): Readonly<RequestQueueState> => {
    const requests = state.requests;
    const filteredRequests = requests.filter((req) => req.id !== props.request.id);
    return {
        ...state,
        requests: filteredRequests,
    };
};

const updateRequestInQueueReducer = (
    state: Readonly<RequestQueueState>,
    props: { requestStatus: CACHED_REQUEST_STATUS },
): Readonly<RequestQueueState> => {
    if (props && props.requestStatus) {
        const [currentUpd, ...rest] = [...state.requests];
        const upd = { ...currentUpd };
        upd.requestStatus = props.requestStatus;
        // update the last attempt time
        upd.modifiedAt = moment().toISOString();
        // no of attempts already made
        upd.attempts++;
        return {
            ...state,
            requests: [upd, ...rest],
        };
    }
    return { ...state };
};

const synchronizeQueueReducer = (state: RequestQueueState): RequestQueueState => {
    // We need to use cloneDeep cause otherwise we are trying to change directly the state which is read-only
    const requests = _.cloneDeep(state.requests);
    requests.forEach((request) => (request.requestStatus = CACHED_REQUEST_STATUS.PENDING));
    return { requests };
};

const createRequestQueueReducer = createReducer(
    initialRequestQueueState,
    on(addRequestToQueue, addRequestToQueueReducer),
    on(removeRequestFromQueue, removeRequestFromQueueReducer),
    on(updateRequestInQueue, updateRequestInQueueReducer),
    on(synchronizeQueue, synchronizeQueueReducer),
);

export function requestQueueReducer(state: Readonly<RequestQueueState>, action: Action): Readonly<RequestQueueState> {
    return createRequestQueueReducer(state, action);
}
